var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 12.328L6 36.828V42H11.172L35.672 17.5L30.5 12.328ZM33.328 9.5L38.5 14.672L41.172 12L36 6.828L33.328 9.5ZM37.414 2.586L45.414 10.586C45.7889 10.9611 45.9996 11.4697 45.9996 12C45.9996 12.5303 45.7889 13.0389 45.414 13.414L13.414 45.414C13.039 45.7891 12.5304 45.9999 12 46H4C3.46957 46 2.96086 45.7893 2.58579 45.4142C2.21071 45.0391 2 44.5304 2 44V36C2.00011 35.4696 2.2109 34.961 2.586 34.586L34.586 2.586C34.9611 2.21106 35.4697 2.00043 36 2.00043C36.5303 2.00043 37.0389 2.21106 37.414 2.586ZM44 42C44.5304 42 45.0391 42.2107 45.4142 42.5858C45.7893 42.9609 46 43.4696 46 44C46 44.5304 45.7893 45.0391 45.4142 45.4142C45.0391 45.7893 44.5304 46 44 46H24C23.4696 46 22.9609 45.7893 22.5858 45.4142C22.2107 45.0391 22 44.5304 22 44C22 43.4696 22.2107 42.9609 22.5858 42.5858C22.9609 42.2107 23.4696 42 24 42H44Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportLight);
export default __webpack_public_path__ + "static/media/ReportLight.1c23154b9093db478c72068f2c678475.svg";
export { ForwardRef as ReactComponent };